<admin-app-header></admin-app-header>

<div class="aff-page">
    <div class="container-fluid">
        <div class="page-header">
            <div>
                <h1>Affiliate statements &amp; reports</h1>
                <p class="subtitle">
                    One fee share per paid invoice: 50% (default) of ParkUpp's Trading Income. When the building was introduced, the building introduction earns and any parker
                    introduction on that invoice does not. Statements are created when an admin clicks Generate (never automatically) and paid by the 25th.
                </p>
            </div>
            <div class="page-header__actions">
                <a class="btn btn-secondary" [routerLink]="['/admin/affiliate-guide']"><i class="fa-solid fa-book"></i> Guide</a>
                <a class="btn btn-secondary" [routerLink]="['/admin/affiliates']"><i class="fa-solid fa-handshake"></i> Affiliates</a>
            </div>
        </div>

        <div class="tabs">
            <button [class.active]="tab === 'requests'" (click)="setTab('requests')">Monthly statements<span class="count" *ngIf="openRequestCount">{{ openRequestCount }}</span></button>
            <button [class.active]="tab === 'bounties'" (click)="setTab('bounties')">Guard bounties<span class="count" *ngIf="bountiesDueCount">{{ bountiesDueCount }}</span></button>
            <button [class.active]="tab === 'parker'" (click)="setTab('parker')">Parker introductions</button>
            <button [class.active]="tab === 'building'" (click)="setTab('building')">Building introductions</button>
            <button [class.active]="tab === 'overlap'" (click)="setTab('overlap')">Overlap</button>
            <button [class.active]="tab === 'integrity'" (click)="setTab('integrity')">Integrity check</button>
        </div>

        <!-- Date range for reports -->
        <div class="card" *ngIf="tab === 'parker' || tab === 'building' || tab === 'overlap'">
            <div class="filters">
                <label class="field">Paid from<input type="date" [(ngModel)]="from" /></label>
                <label class="field">Paid to<input type="date" [(ngModel)]="to" /></label>
                <button class="btn btn-primary" (click)="loadReport()" [disabled]="reportLoading">
                    <i class="fa-solid fa-spinner fa-spin" *ngIf="reportLoading"></i> Run report
                </button>
                <button class="btn btn-secondary" (click)="exportCsv($any(tab))" [disabled]="!reportLoaded"><i class="fa-solid fa-file-csv"></i> Export CSV</button>
                <span class="muted" *ngIf="reportLoaded">{{ commissions.length }} paid invoices with an affiliate claim in this period</span>
            </div>
        </div>

        <!-- Requests -->
        <div class="card" *ngIf="tab === 'requests'">
            <div class="card__head">
                <h2>Monthly statements</h2>
                <div class="filters">
                    <label class="field">Month<input type="month" [(ngModel)]="statementPeriod" /></label>
                    <button class="btn btn-primary btn-sm" (click)="generateStatements()" [disabled]="generating || !statementPeriod">
                        <i class="fa-solid fa-spinner fa-spin" *ngIf="generating"></i> Generate statements
                    </button>
                </div>
                <div class="field">
                    <select [(ngModel)]="requestFilter">
                        <option value="open">Open</option>
                        <option value="all">All</option>
                    </select>
                </div>
            </div>
            <div class="loading" *ngIf="requestsLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>
            <div class="empty" *ngIf="!requestsLoading && !visibleRequests.length">No {{ requestFilter === 'open' ? 'open ' : '' }}statements. Choose a month and click Generate statements.</div>
            <div class="table-wrap" *ngIf="!requestsLoading && visibleRequests.length">
                <table class="aff-table">
                    <thead>
                        <tr>
                            <th>Month</th>
                            <th>Affiliate</th>
                            <th>Bank</th>
                            <th class="num">Lines</th>
                            <th class="num">Amount</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let r of visibleRequests">
                            <tr>
                                <td>
                                    {{ r.period ? (r.period + '-01' | date: 'MMMM y') : (r.requestedAt | date: 'd MMM y') }}
                                    <span class="sub" *ngIf="r.dueDate">Pay by {{ r.dueDate | date: 'd MMM' }}</span>
                                </td>
                                <td>
                                    <a [routerLink]="['/admin/affiliates', r.affiliateUid]">{{ r.affiliateName }}</a><span class="sub">{{ r.affiliateCode }}</span>
                                </td>
                                <td>
                                    <span *ngIf="!r.payoutDetails" class="sub">No bank details yet (picked up when marked paid)</span>
                                    {{ r.payoutDetails?.bank }} · {{ r.payoutDetails?.accountNumber }}
                                    <span class="sub">{{ r.payoutDetails?.accountHolder }} · branch {{ r.payoutDetails?.branchCode || '—' }}</span>
                                </td>
                                <td class="num">
                                    <button class="btn btn-secondary btn-sm" (click)="toggle(r.id)">{{ r.lines.length }} <i class="fa-solid" [ngClass]="expanded.has(r.id) ? 'fa-chevron-up' : 'fa-chevron-down'"></i></button>
                                </td>
                                <td class="num">
                                    <strong>R {{ r.amount | number: '1.2-2' }}</strong>
                                    <span class="sub" *ngIf="r.clawbackAmount">R {{ r.grossAmount | number: '1.2-2' }} less R {{ r.clawbackAmount | number: '1.2-2' }} refunds</span>
                                </td>
                                <td>
                                    <span class="badge" [ngClass]="'badge--' + r.status">{{ r.status === 'requested' ? 'Due' : (r.status | titlecase) }}</span>
                                    <span class="sub" *ngIf="r.reference">Ref {{ r.reference }}</span>
                                    <span class="sub" *ngIf="r.rejectionReason">{{ r.rejectionReason }}</span>
                                </td>
                                <td class="num">
                                    <button class="btn btn-secondary btn-sm" *ngIf="r.status === 'requested'" (click)="action(r, 'approve')">Approve</button>
                                    <button class="btn btn-primary btn-sm" *ngIf="r.status === 'requested' || r.status === 'approved'" (click)="action(r, 'pay')">Mark paid</button>
                                    <button class="btn btn-danger btn-sm" *ngIf="r.status === 'requested' || r.status === 'approved'" (click)="action(r, 'reject')">Reject</button>
                                </td>
                            </tr>
                            <tr *ngIf="expanded.has(r.id)">
                                <td colspan="7" style="background: #f5f7fa">
                                    <table class="aff-table">
                                        <thead>
                                            <tr>
                                                <th>Paid</th>
                                                <th>Building / parker</th>
                                                <th>Type</th>
                                                <th class="num">Invoice</th>
                                                <th class="num">Fee share</th>
                                                <th>Other claims on this invoice</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let l of r.lines">
                                                <td>{{ l.paymentDate | date: 'd MMM y' }}</td>
                                                <td>
                                                    {{ l.denormParkingTitle }}<span class="sub">{{ l.denormClientName }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge" [ngClass]="'badge--' + (l.winnerType === 'parker' ? 'parker' : 'landlord')">{{ l.winnerType | titlecase }}</span>
                                                </td>
                                                <td class="num">R {{ l.grossAmount | number: '1.2-2' }}</td>
                                                <td class="num" [class.strike]="l.isClawback">{{ l.isClawback ? '−' : '' }}R {{ l.amount | number: '1.2-2' }}</td>
                                                <td>
                                                    <span *ngIf="l.isClawback" class="sub">Refunded after payout: deducted</span>
                                                    <span *ngFor="let o of lineOthers(l)" class="sub">{{ o.type | titlecase }}: {{ o.name }} · {{ outcomeLabel(o.outcome) }}</span>
                                                    <span *ngIf="!l.isClawback && !lineOthers(l).length" class="sub">—</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Parker / landlord reports -->
        <ng-container *ngIf="(tab === 'parker' || tab === 'building') && reportLoaded">
            <div class="card">
                <div class="card__head">
                    <h2>{{ tab === 'parker' ? 'Parker introduction' : 'Building introduction' }} fee shares by affiliate</h2>
                </div>
                <div class="empty" *ngIf="!totalsFor($any(tab)).length">No {{ tab }} introduction fee shares in this period.</div>
                <div class="table-wrap" *ngIf="totalsFor($any(tab)).length">
                    <table class="aff-table">
                        <thead>
                            <tr>
                                <th>Affiliate</th>
                                <th class="num">Invoices</th>
                                <th class="num">Revenue</th>
                                <th class="num">Fee share</th>
                                <th class="num">This month</th>
                                <th class="num">Carried forward</th>
                                <th class="num">On statement</th>
                                <th class="num">Paid</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let t of totalsFor($any(tab))">
                                <td>
                                    <a [routerLink]="['/admin/affiliates', t.affiliateUid]">{{ t.name }}</a><span class="sub">{{ t.code }}</span>
                                </td>
                                <td class="num">{{ t.invoices }}</td>
                                <td class="num">R {{ t.gross | number: '1.2-2' }}</td>
                                <td class="num">R {{ t.commission | number: '1.2-2' }}</td>
                                <td class="num">R {{ t.pending | number: '1.2-2' }}</td>
                                <td class="num">R {{ t.approved | number: '1.2-2' }}</td>
                                <td class="num">R {{ t.requested | number: '1.2-2' }}</td>
                                <td class="num">R {{ t.paid | number: '1.2-2' }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total</td>
                                <td class="num">{{ sum(totalsFor($any(tab)), 'invoices') }}</td>
                                <td class="num">R {{ sum(totalsFor($any(tab)), 'gross') | number: '1.2-2' }}</td>
                                <td class="num">R {{ sum(totalsFor($any(tab)), 'commission') | number: '1.2-2' }}</td>
                                <td class="num">R {{ sum(totalsFor($any(tab)), 'pending') | number: '1.2-2' }}</td>
                                <td class="num">R {{ sum(totalsFor($any(tab)), 'approved') | number: '1.2-2' }}</td>
                                <td class="num">R {{ sum(totalsFor($any(tab)), 'requested') | number: '1.2-2' }}</td>
                                <td class="num">R {{ sum(totalsFor($any(tab)), 'paid') | number: '1.2-2' }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <div class="card" *ngIf="linesFor($any(tab)).length">
                <div class="card__head"><h2>Invoices</h2></div>
                <div class="table-wrap">
                    <table class="aff-table">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Invoice</th>
                                <th>Building</th>
                                <th>{{ tab === 'parker' ? 'Parker' : 'Portfolio' }}</th>
                                <th>Affiliate</th>
                                <th class="num">Invoice</th>
                                <th class="num">Trading Income</th>
                                <th class="num">Fee share</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of linesFor($any(tab))">
                                <td>{{ c.paymentDate | date: 'd MMM y' }}</td>
                                <td>
                                    <a *ngIf="c.clientKey" [routerLink]="['/client', c.clientKey, 'invoice', c.invoiceKey]">#{{ c.invoiceNumber || c.invoiceKey.slice(0, 6) }}</a>
                                </td>
                                <td>{{ c.denormParkingTitle }}</td>
                                <td>{{ tab === 'parker' ? c.denormClientName : c.denormMerchantCompanyName }}</td>
                                <td>{{ name(c.winnerAffiliateUid) }}</td>
                                <td class="num">R {{ c.grossAmount | number: '1.2-2' }}</td>
                                <td class="num">R {{ c.basisAmount | number: '1.2-2' }}</td>
                                <td class="num">R {{ c.amount | number: '1.2-2' }}</td>
                                <td>
                                    <span class="badge" [ngClass]="'badge--' + c.status">{{ c.status | titlecase }}</span>
                                    <span class="sub" *ngIf="c.hasOverlap">Overlap: see Overlap tab</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>

        <!-- Overlap -->
        <ng-container *ngIf="tab === 'overlap' && reportLoaded">
            <div class="stats-grid">
                <div class="stat">
                    <span class="stat__value">{{ overlapLines.length }}</span>
                    <span class="stat__label">Invoices with competing or suppressed claims</span>
                </div>
                <div class="stat">
                    <span class="stat__value">{{ overlapByBuilding.length }}</span>
                    <span class="stat__label">Buildings affected</span>
                </div>
                <div class="stat stat--green">
                    <span class="stat__value">R {{ totalAvoided | number: '1.2-2' }}</span>
                    <span class="stat__label">Commission not paid (suppressed)</span>
                </div>
                <div class="stat" [class.stat--red]="doubleEarnedCount > 0" [class.stat--green]="doubleEarnedCount === 0">
                    <span class="stat__value">{{ doubleEarnedCount }}</span>
                    <span class="stat__label">Invoices paid twice (must be 0)</span>
                </div>
            </div>

            <div class="card">
                <div class="card__head">
                    <h2>By building</h2>
                    <span class="muted">Buildings where more than one referral had a claim, or a claim was suppressed.</span>
                </div>
                <div class="empty" *ngIf="!overlapByBuilding.length">No overlaps in this period.</div>
                <div class="table-wrap" *ngIf="overlapByBuilding.length">
                    <table class="aff-table">
                        <thead>
                            <tr>
                                <th>Building</th>
                                <th>Building introduction</th>
                                <th>Parker referrals</th>
                                <th class="num">Invoices</th>
                                <th class="num">Paid out</th>
                                <th class="num">Not paid</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let b of overlapByBuilding">
                                <td>
                                    {{ b.building }}<span class="sub">{{ b.portfolio }}</span>
                                </td>
                                <td>
                                    <span *ngFor="let n of b.landlordAffiliates" class="sub">{{ n }}</span><span *ngIf="!b.landlordAffiliates.length" class="sub">—</span>
                                </td>
                                <td>
                                    <span *ngFor="let n of b.parkerAffiliates" class="sub">{{ n }}</span><span *ngIf="!b.parkerAffiliates.length" class="sub">—</span>
                                </td>
                                <td class="num">{{ b.invoices }}</td>
                                <td class="num">R {{ b.paid | number: '1.2-2' }}</td>
                                <td class="num">R {{ b.avoided | number: '1.2-2' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card" *ngIf="overlapLines.length">
                <div class="card__head"><h2>Invoices</h2></div>
                <div class="table-wrap">
                    <table class="aff-table">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Invoice</th>
                                <th>Building / parker</th>
                                <th>Building claim</th>
                                <th>Parker claim</th>
                                <th class="num">Paid out</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of overlapLines">
                                <td>{{ c.paymentDate | date: 'd MMM y' }}</td>
                                <td>
                                    <a *ngIf="c.clientKey" [routerLink]="['/client', c.clientKey, 'invoice', c.invoiceKey]">#{{ c.invoiceNumber || c.invoiceKey.slice(0, 6) }}</a>
                                </td>
                                <td>
                                    {{ c.denormParkingTitle }}<span class="sub">{{ c.denormClientName }}</span>
                                </td>
                                <td>
                                    <ng-container *ngIf="candidate(c, ReferralType.LANDLORD) as l">
                                        <span [class.strike]="l.outcome !== Outcome.EARNED">{{ name(l.affiliateUid) }} · R {{ l.amount | number: '1.2-2' }}</span>
                                        <span class="sub">{{ outcomeLabel(l.outcome) }}</span>
                                    </ng-container>
                                    <span *ngIf="!candidate(c, ReferralType.LANDLORD)" class="sub">—</span>
                                </td>
                                <td>
                                    <ng-container *ngIf="candidate(c, ReferralType.PARKER) as p">
                                        <span [class.strike]="p.outcome !== Outcome.EARNED">{{ name(p.affiliateUid) }} · R {{ p.amount | number: '1.2-2' }}</span>
                                        <span class="sub">{{ outcomeLabel(p.outcome) }}</span>
                                    </ng-container>
                                    <span *ngIf="!candidate(c, ReferralType.PARKER)" class="sub">—</span>
                                </td>
                                <td class="num">R {{ c.amount | number: '1.2-2' }} <span class="sub">{{ c.status }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>

        <div class="loading" *ngIf="(tab === 'parker' || tab === 'building' || tab === 'overlap') && reportLoading && !reportLoaded">
            <i class="fa-solid fa-spinner fa-spin"></i> Loading...
        </div>

        <!-- Security guard bounties -->
        <div class="card" *ngIf="tab === 'bounties'">
            <div class="card__head">
                <div>
                    <h2>Guard bounties</h2>
                    <p class="muted">
                        Security guards earn a flat amount once per parker they bring, when that parker has paid the guard's set number of invoices. Pay them by cash, airtime or EFT,
                        then record it here. Bounties are separate from monthly statements.
                    </p>
                </div>
                <div class="filters">
                    <span class="muted">Due: R {{ bountiesDueTotal | number: '1.2-2' }}</span>
                    <div class="field">
                        <select [(ngModel)]="bountyFilter">
                            <option value="due">Due</option>
                            <option value="all">All</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="loading" *ngIf="!bountiesLoaded"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>
            <div class="empty" *ngIf="bountiesLoaded && !visibleBounties.length">No {{ bountyFilter === 'due' ? 'bounties due' : 'bounties yet' }}.</div>
            <div class="table-wrap" *ngIf="bountiesLoaded && visibleBounties.length">
                <table class="aff-table">
                    <thead>
                        <tr>
                            <th>Guard</th>
                            <th>Parker</th>
                            <th>Due since</th>
                            <th class="num">Amount</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let b of visibleBounties">
                            <td>
                                <a [routerLink]="['/admin/affiliates', b.affiliateUid]">{{ b.affiliateName || b.affiliateUid }}</a>
                                <span class="sub">{{ b.affiliateCode }}{{ b.affiliatePhone ? ' · ' + b.affiliatePhone : '' }}</span>
                            </td>
                            <td>
                                <a [routerLink]="['/client', b.clientKey]">{{ b.denormClientName || b.clientKey }}</a>
                                <span class="sub">{{ b.paidInvoicesAtQualifying }} paid invoices (needs {{ b.threshold }})</span>
                            </td>
                            <td>{{ b.qualifiedAt | date: 'd MMM y' }}</td>
                            <td class="num">R {{ b.amount | number: '1.2-2' }}</td>
                            <td>
                                <span class="badge" [ngClass]="'badge--' + b.status">{{ b.status | titlecase }}</span>
                                <span class="sub" *ngIf="b.paidAt">{{ b.paidAt | date: 'd MMM y' }} · {{ methodLabel(b.paymentMethod) }}{{ b.reference ? ' · ' + b.reference : '' }}</span>
                                <span class="sub" *ngIf="b.notes">{{ b.notes }}</span>
                            </td>
                            <td class="num">
                                <button class="btn btn-primary btn-sm" *ngIf="b.status === BountyStatus.DUE" (click)="openPay(b)">Mark paid</button>
                                <button class="btn btn-danger btn-sm" *ngIf="b.status === BountyStatus.DUE" (click)="bountyCancel(b, 'cancel')">Cancel</button>
                                <button class="btn btn-secondary btn-sm" *ngIf="b.status === BountyStatus.CANCELLED" (click)="bountyCancel(b, 'reopen')">Reopen</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Integrity -->
        <div class="card" *ngIf="tab === 'integrity'">
            <div class="card__head">
                <div>
                    <h2>Integrity check</h2>
                    <p class="muted">
                        Recomputes from invoices and referrals: paid invoices that should have a commission record but don't, commissions on invoices that are no longer paid, and any
                        invoice that earned twice.
                    </p>
                </div>
            </div>
            <div class="filters">
                <label class="field">Invoices paid since<input type="date" [(ngModel)]="integrityFrom" /></label>
                <button class="btn btn-primary" (click)="runIntegrity(false)" [disabled]="integrityRunning">
                    <i class="fa-solid fa-spinner fa-spin" *ngIf="integrityRunning"></i> Run check
                </button>
                <button
                    class="btn btn-secondary"
                    (click)="runIntegrity(true)"
                    [disabled]="integrityRunning || !integrity || (!integrity.missing.length && !integrity.stale.length)"
                >
                    Fix issues
                </button>
            </div>
            <div *ngIf="integrity" style="margin-top: 16px">
                <div class="notice" [ngClass]="integrity.missing.length || integrity.stale.length || integrity.doubleEarned.length ? 'notice--bad' : 'notice--ok'">
                    Checked {{ integrity.checkedInvoices }} invoices. Missing commission records: {{ integrity.missing.length }}. Stale commissions: {{ integrity.stale.length }}. Paid
                    twice: {{ integrity.doubleEarned.length }}.<span *ngIf="integrity.fixed"> Fixed {{ integrity.fixed }}.</span
                    ><span *ngIf="integrity.bountiesCreated"> New guard bounties due: {{ integrity.bountiesCreated }}.</span>
                </div>
                <p class="muted" *ngIf="integrity.missing.length">Missing: {{ integrity.missing.join(', ') }}</p>
                <p class="muted" *ngIf="integrity.stale.length">Stale: {{ integrity.stale.join(', ') }}</p>
                <p class="muted" *ngIf="integrity.doubleEarned.length">Paid twice: {{ integrity.doubleEarned.join(', ') }}</p>
            </div>
        </div>
    </div>
</div>

<!-- Mark a guard bounty paid -->
<div class="modal-backdrop-aff" *ngIf="paying" (click)="paying = null">
    <div class="modal-aff" (click)="$event.stopPropagation()">
        <h3>Pay R{{ paying.amount }} to {{ paying.affiliateName }}</h3>
        <p class="muted">For bringing {{ paying.denormClientName || 'a parker' }}.<span *ngIf="paying.affiliatePhone"> Cellphone: {{ paying.affiliatePhone }}.</span></p>
        <div class="form-grid">
            <label class="field"
                >Paid by
                <select [(ngModel)]="payment.method">
                    <option *ngFor="let m of paymentMethods" [value]="m">{{ methodLabel(m) }}</option>
                </select>
            </label>
            <label class="field">Reference (voucher, EFT ref or receipt)<input [(ngModel)]="payment.reference" maxlength="100" /></label>
            <label class="field" style="grid-column: 1 / -1">Notes<input [(ngModel)]="payment.notes" maxlength="500" /></label>
        </div>
        <div class="modal-aff__actions">
            <button class="btn btn-secondary" (click)="paying = null">Cancel</button>
            <button class="btn btn-primary" (click)="confirmPay()">Mark paid</button>
        </div>
    </div>
</div>
